import React from "react"
import SideNav from "react-simple-sidenav"

class BookingSideNav extends SideNav {
    constructor(props) {
        super(props)
    }
    
    render() {
        const styles = super.getStyle()
        return (
            <aside style={styles.root}>
                <div style={styles.overlay} onClick={super.hideNav.bind(this)} />
                <nav style={styles.nav} ref="nav">
                    {this.props.children || super.getDefaultContent()}
                </nav>
            </aside>
        )
    }
}

export default BookingSideNav



// WEBPACK FOOTER //
// ./client/components/BookingSideNav/BookingSideNav.js